import CheckFeature from '../checkfeature'
import store from '@/store'
import { Feature } from '../featureFlags'

export default class StreamAuthentication extends CheckFeature {

  hasFeature (): boolean {
    return store.state.admin.featureFlags.get(Feature.STREAM_AUTHENTICATION) ?? false
  }

  teamHasFeature (_teamId: string): boolean {
    return false
  }

  updateTeamFeature (_teamId: string, _enabled: boolean): void {
  }

  isGlobalFeature (): boolean {
    return true
  }
}
